export const loginRoutes = [
  "/register",
  "/Register",
  "/login",
  "/Login",
  "/changes",
  "/Changes",
  "/recoverpassword",
  "/RecoverPassword",
  "/recoverPassword",
  "/recoverupdate",
  "/recoverUpdate",
  "/RecoverUpdate",
  "/directory",
  "/Directory",
  "/sendmoney",
  "/SendMoney",
  "/recharge",
  "/Recharge",
  "/profile",
  "/Profile",
  "/movements",
  "/Movements",
  "/accadm",
  "/accAdm",
  "/AccAdm",
  "/admindashboard",
  "/AdminDashboard",
  "/adminDashboard",
  "/users",
  "/Users",
  "/usersr",
  "/usersR",
  "/UsersR",
  "/userse",
  "/usersE",
  "/UsersE",
  "/usersv",
  "/usersV",
  "/UsersV",
  "/currencyprice",
  "/currencyPrice",
  "/CurrencyPrice",
  "/banks",
  "/Banks",
  "/relation",
  "/Relation",
  "/termsandconditions",
  "/termsAndConditions",
  "/TermsAndConditions",
  "/privacy",
  "/Privacy",
  "/Homeusa",
  "/homeusa",
  "/HomeUsa",
];

export const banksByCountry = {
  Venezuela: [
    "0102 - Banco de Venezuela",
    "0104 - Banco Venezolano de Crédito",
    "0105 - Banco Mercantil",
    "0108 - Banco Provincial",
    "0114 - Banco del Caribe",
    "0115 - Banco Exterior",
    "0128 - Banco Caroní",
    "0134 - Banesco",
    "0137 - Banco Sofitasa",
    "0138 - Banco Plaza",
    "0146 - Banco de la Gente Emprendedora",
    "0151 - Banco Fondo Común",
    "0156 - 100% Banco",
    "0157 - DelSur",
    "0163 - Banco del Tesoro",
    "0166 - Banco Agrícola de Venezuela",
    "0168 - Bancrecer ",
    "0169 - Mi Banco",
    "0171 - Banco Activo",
    "0172 - Bancamiga",
    "0173 - Banco Internacional de Desarrollo",
    "0174 - Banplus",
    "0175 - Banco Digital de los Trabajadores",
    "0177 - Banco de la Fuerza Armada Nacional Bolivariana",
    "0178 - Banco Digital",
    "0191 - Banco Nacional de Crédito",
    "0601 - Instituto Municipal de Crédito Popular",
  ],
  Argentina: [
    "Banco de la Nación Argentina",
    "Banco de la Provincia de Buenos Aires",
    "Banco de la Ciudad de Buenos Aires",
    "Banco Galicia",
    "Banco Santander Río",
    "Banco BBVA Argentina",
    "Banco Macro",
    "Banco Patagonia",
    "Banco Supervielle",
    "Banco Itaú Argentina",
    "Banco Comafi",
    "Banco Hipotecario",
    "Banco Credicoop",
    "Banco Industrial",
  ],
  // Agrega más países y sus bancos aquí
  Colombia: [
    "Banco de Bogotá",
    "Banco de Occidente",
    "Banco Popular",
    "Bancolombia",
    "Banco Davivienda",
    "Banco AV Villas",
    "Banco Caja Social",
    "Banco GNB Sudameris",
    "Banco Pichincha",
    "Bancoomeva",
    "Banco Falabella",
  ],
  Chile: [
    "Banco de Chile",
    "Banco Internacional",
    "Banco Itaú",
    "Banco Santander",
    "Banco Security",
    "BancoEstado",
    "BBVA",
    "BCI",
    "Corpbanca",
    "Scotiabank",
  ],
  Ecuador: [
    "Banco del Pacífico",
    "Banco Pichincha",
    "Banco de Guayaquil",
    "Banco Internacional",
    "Produbanco",
    "Banco Bolivariano",
    "Banco del Austro",
    "Banco Solidario",
  ],
  Panama: [
    "Banco Nacional de Panamá",
    "Caja de Ahorros",
    "Banco General",
    "Banistmo",
    "BAC Credomatic",
    "Global Bank",
    "Multibank",
    "Scotiabank",
  ],
  Mexico: [
    "BBVA Bancomer",
    "Banamex",
    "Santander",
    "Banorte",
    "HSBC",
    "Scotiabank",
    "Inbursa",
    "Banco Azteca",
  ],
  Brasil: [
    "Banco do Brasil",
    "Caixa Econômica Federal",
    "Banco Bradesco",
    "Banco Itaú",
    "Banco Santander",
    "Banco Safra",
    "Banco BTG Pactual",
    "Banco Votorantim",
  ],
  Peru: [
    "Banco de Crédito del Perú",
    "BBVA Continental",
    "Interbank",
    "Scotiabank",
    "Banco Pichincha",
    "Banco Falabella",
    "Banco Ripley",
    "Banco Azteca",
  ],
  Uruguay: [
    "Banco de la República Oriental del Uruguay",
    "Banco Itaú Uruguay",
    "Banco Santander Uruguay",
    "BROU",
    "Scotiabank Uruguay",
    "HSBC Uruguay",
    "Citibank Uruguay",
  ],
  Paraguay: [
    "Banco Nacional de Fomento",
    "Banco Itaú Paraguay",
    "Banco Continental",
    "Banco Regional",
    "Banco Familiar",
    "Banco Sudameris Paraguay",
    "Banco GNB Paraguay",
  ],
  Bolivia: [
    "Banco de Crédito de Bolivia",
    "Banco Nacional de Bolivia",
    "Banco Mercantil Santa Cruz",
    "Banco BISA",
    "Banco Ganadero",
    "Banco FIE",
    "BancoSol",
    "Banco Económico",
  ],
  "Estados Unidos": ["Bank of America"],
  Europa: [
    "Banco Santander",
    "BBVA",
    "CaixaBank",
    "Sabadell",
    "Cajamar",
    "Ruralvia",
    "Revolut",
    "Wise",
    "Otros bancos europeos",
  ],
  Dominicana: [
    "Banco Popular Dominicano",
    "Banco de Reservas de la República Dominicana",
    "Banco BHD León",
    "Banco Santa Cruz",
    "Banco Vimenca",
    "Banco Caribe",
    "Banco Promerica",
    "Banco Ademi",
    "Banco López de Haro",
    "Banco BDI",
    "Banco Agrícola",
    "Banco Banreservas",
    "Banco Banesco",
    "Banco del Progreso, S.A.",
    "Banco de Ahorro y Crédito ADOPEM, S.A.",
  ],
};
